import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  HostListener,
  inject,
  Input,
  Renderer2,
  RendererStyleFlags2,
  ViewChild,
} from '@angular/core';

import { SpaDayLoadDTO } from '@api';

@Component({
  selector: 'spa-report-spa-bar-chart',
  templateUrl: './report-bar-chart.component.html',
  styleUrls: ['./report-bar-chart.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReportBarChartComponent {
  private readonly element = inject(ElementRef);
  private readonly renderer = inject(Renderer2);

  @Input() loads: SpaDayLoadDTO | undefined;
  @ViewChild('spaDiagram') spaDiagram: ElementRef | undefined;

  indexOfHoveredBar = -1;
  parentXPosition: number | null = null;

  // Occupancy traffic-light: plenty free is on-brand green, filling up is amber, nearly full is alert red.
  manyAvailableColor = getComputedStyle(document.documentElement).getPropertyValue('--forest-700');
  someAvailableColor = getComputedStyle(document.documentElement).getPropertyValue('--warning-500');
  lessAvailableColor = getComputedStyle(document.documentElement).getPropertyValue('--error-500');
  pastColor = getComputedStyle(document.documentElement).getPropertyValue('--slate-300');

  public xAxisTicks = Array.from({ length: 11 }, (_, i) => {
    const value = i * 10;
    const position = i * 10;
    return {
      value: value, // value to be shown
      position: position, // calculate position as percentage of axis width
    };
  });

  get xPosition(): number {
    return this.spaDiagram?.nativeElement?.getBoundingClientRect().x;
  }

  @HostListener('window:resize')
  onResize(): void {
    this.parentXPosition = this.xPosition;
  }

  onHover(event: MouseEvent): void {
    const mouseX = event.clientX;
    this.renderer.setStyle(
      this.element.nativeElement,
      `--tooltip-x-position`,
      mouseX - (this.parentXPosition ?? 0) + 'px',
      RendererStyleFlags2.DashCase,
    );
  }

  enteredDiagramElement(i: number) {
    if (!this.parentXPosition) {
      this.parentXPosition = this.xPosition;
    }

    this.indexOfHoveredBar = i;
  }

  leftDiagramElement() {
    this.indexOfHoveredBar = -1;
  }
}

export enum DiagramMarking {
  arrow,
  line,
}
